import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ce50f2dc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ce50f2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce50f2dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce50f2dc')) {
      api.createRecord('ce50f2dc', component.options)
    } else {
      api.reload('ce50f2dc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ce50f2dc&scoped=true&", function () {
      api.rerender('ce50f2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N2sebWrya0Xw/JS/comp/PopupBox.vue"
export default component.exports